var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnclosedRedCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(-872 -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quit",
    transform: "translate(872 800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,1.5A10.5,10.5,0,1,0,22.5,12,10.512,10.512,0,0,0,12,1.5Zm0,0",
    fill: "#fa1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M7.032,15.206a.75.75,0,0,1-.53-1.281L13.927,6.5a.75.75,0,0,1,1.061,1.061L7.563,14.986a.751.751,0,0,1-.531.22Zm0,0",
    transform: "translate(1.256 1.256)",
    fill: "#fa1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M14.456,15.206a.744.744,0,0,1-.53-.22L6.5,7.562A.75.75,0,0,1,7.562,6.5l7.425,7.425a.749.749,0,0,1-.531,1.28Zm0,0",
    transform: "translate(1.256 1.256)",
    fill: "#fa1616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnclosedRedCloseIcon);
export default __webpack_public_path__ + "static/media/enclosed-red-close-icon.83b97f5d3d68e414089af7b14203907e.svg";
export { ForwardRef as ReactComponent };